import { TemperatureCelsiusIcon } from './TemperatureCelsiusIcon';

/**
 * author: Austin Andrews
 * id A94E333D-F8C5-4726-B81A-6DDF4CC37FD0
 * name temperature-celsius
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/temperature-celsius.svg
 * tags
 * - Weather 
 */
export const TemperatureCentigradeIcon = TemperatureCelsiusIcon;
export default TemperatureCentigradeIcon